import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

import {UrlBuilder} from "../url-builder/url.builder";
import {ClientList} from "./listclientsdata";


@Injectable({
  providedIn: 'root'
})
export class ListClientsDataService {

  private uiUrl: string = "";
  private url: UrlBuilder;

  constructor(private http: HttpClient) {
    this.url = new UrlBuilder();
  }

  // GetData(): Observable<ListClients> {
  //   this.uiUrl = "http://monitor.sercom.nl:41680/climates.php";
  //   console.log('FILE: ' + this.uiUrl);
  //   return this.http.get<ListClients>(this.uiUrl);
  // }

  GetData(): Observable<ClientList> {
    return this.http.get<ClientList>(this.url.GetClimateListUrl());


  }



}

